/*
  This file is separated from ../utils/index.js because it depends on
  ./filter-definitions, which is highly dependent on lodash. We want
  to avoid pulling in lodash as a dependency, in particular for the
  search form.
 */

import type { FiltersState } from "@app/modules/results/state/filters";
import type { TranslatorService } from "@app/services/translator";
import type { ExperimentsFeatures } from "@app/types/experiments";
import type { ResultsReduxState } from "@app/types/results-redux-types";

import {
  DEFAULT_VEHICLE_CATEGORY_KEY,
  DEFAULT_VEHICLE_LAYOUT_TYPE_KEY
} from "../constants/filters";
import { getExperiments } from "../selectors/state-accessors";
import { getDefaultExcludedSources } from "../state/helpers/inventory-helpers";

export function getInventoryCountLabel(
  inventory_count: number,
  translator: TranslatorService
): string {
  return inventory_count === 1
    ? translator.t("!results.showing.label.singular")
    : translator.t("!results.showing.label", {
        total: inventory_count
      });
}

function getSafeResultsReduxState(): ResultsReduxState | null {
  if (typeof window === "undefined") {
    return null;
  }

  const state: ResultsReduxState | null = window?.store?.getState?.();
  return state || null;
}

export const base_initial_results_state: FiltersState = {
  vehicle_layout_type: DEFAULT_VEHICLE_LAYOUT_TYPE_KEY,
  vehicle_category: DEFAULT_VEHICLE_CATEGORY_KEY,
  origin_location: [], // query param location filtering
  destination_location: [], // query param location filtering
  origin_poi: [],
  destination_poi: [],
  // origin: [], // location filters in filters sidebar
  // destination: [], // location filters in filters sidebar
  amenities: [],
  excluded_sources: [],
  operator_ids: [],
  profile_ids: [],
  departure_time_ranges: [],
  has_e_ticket: [],
  is_direct_only: [],
  vehicle_type: [],
  award_winners_only: [],
  classes: [],
  max_price: []
};

function buildInitialResultsState(
  experiments: ExperimentsFeatures | null
): FiltersState {
  if (!experiments) {
    return base_initial_results_state;
  }

  const excluded_sources = getDefaultExcludedSources();

  return {
    ...base_initial_results_state,
    excluded_sources
  };
}

export function buildClientInitialResultsState(): FiltersState {
  const state = getSafeResultsReduxState();
  if (!state) {
    return base_initial_results_state;
  }

  const features = getExperiments(state);
  return buildInitialResultsState(features);
}
